export default function sanitizePhoneNumber(phoneNumber?: string) {
  if (!phoneNumber) return undefined;

  return phoneNumber.replace(/\D/g, '');
}
